(() => {
  if (window.fflRadarSeriesGuard) return;
  window.fflRadarSeriesGuard = true;
  const setup = () => {
    const c = document.querySelector('#FFLCustomizer');
    const element = document.querySelector('[data-ffl-radar-config]');
    const form = document.querySelector('product-form form[action*="/cart/add"]');
    if (!c || !element || !form) return;
    let config;
    try { config = JSON.parse(element.textContent); } catch { return; }
    if (window.routes) window.routes.cart_add_url = (window.Shopify?.routes?.root || '/') + 'cart/add.js';
    if (!c.querySelector('[data-radar-fields]')) {
      const group = document.createElement('div');
      group.dataset.radarFields = '';
      group.className = 'ffl-radar-fields';
      for (const field of config.fields) {
        const label = document.createElement('label');
        const input = document.createElement(field.kind === 'textarea' ? 'textarea' : 'input');
        if (input instanceof HTMLInputElement) input.type = 'text';
        input.name = 'properties[' + field.key + ']';
        input.required = !!field.required;
        input.maxLength = field.max;
        label.append(document.createTextNode(field.label + (field.required ? ' *' : '')), input);
        group.append(label);
      }
      const label = document.createElement('label');
      label.className = 'ffl-radar-confirmation';
      const check = document.createElement('input');
      check.type = 'checkbox'; check.required = true;
      check.name = 'properties[Design scope confirmation]';
      check.value = config.scope;
      label.append(check, document.createTextNode(config.confirmation));
      group.append(label);
      c.querySelector('[data-customizer-step]').append(group);
      const hidden = document.createElement('input');
      hidden.type = 'hidden'; hidden.name = 'properties[_Design ID]'; hidden.value = config.code;
      c.append(hidden);
    }
    c.querySelectorAll('input,select,textarea').forEach(f => f.setAttribute('form', form.getAttribute('id')));
    const name = c.querySelector('[name="properties[Personalized name]"]');
    if (name) name.maxLength = 24;
    const message = c.querySelector('[name="properties[Personalized message]"]');
    if (message) message.maxLength = config.messagesMax;
    const dates = c.querySelector('.ffl-builder__lettering-row input[name*="date" i]');
    if (dates) dates.maxLength = 40;
    if (config.yearOnly) {
      const year = c.querySelector('[name="properties[Personalized year]"]');
      if (year) { year.maxLength = 4; year.pattern = '[0-9]{4}'; year.inputMode = 'numeric'; year.title = 'Enter a four-digit year.'; }
    }
  };
  setup();
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('product-form form[action*="/cart/add"]')) return;
    setup();
    const c = document.querySelector('#FFLCustomizer');
    const invalid = c && [...c.querySelectorAll('input,select,textarea')].find(f => !f.disabled && !f.checkValidity());
    if (!c || invalid) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (invalid) { invalid.closest('details')?.setAttribute('open', ''); invalid.scrollIntoView({behavior: 'smooth', block: 'center'}); invalid.focus({preventScroll: true}); invalid.reportValidity(); }
    }
  }, true);
})();
